import { SEARCH_RESULTS_SUMMARY_ID } from "../constants/searchResultsSummary";

export const focusSearchResultsSummary = (
    element?: HTMLElement | null
): void => {
    const target =
        element ?? document.getElementById(SEARCH_RESULTS_SUMMARY_ID);

    if (!target) {
        return;
    }

    target.scrollIntoView({ block: "start", behavior: "auto" });
    target.focus({ preventScroll: true });
};
